import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { SiteSettingsProvider } from "./context/SiteSettingsContext";
import { LanguageProvider } from "./i18n/LanguageContext";
import SiteLayout from "./components/SiteLayout";
import Home from "./pages/Home";
import CorporateSolutions from "./pages/CorporateSolutions";
import ServiceLanding from "./pages/ServiceLanding";
import DrAi from "./pages/DrAi";
import DrAiUret from "./pages/DrAiUret";
import BursaLanding from "./pages/BursaLanding";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import ProjectRequest from "./pages/ProjectRequest";
import LegalPage from "./pages/LegalPage";
import TasFlow from "./pages/TasFlow";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import { BrandAuthProvider } from "./context/BrandAuthContext";
import BrandLogin from "./pages/brand/BrandLogin";
import BrandPortal from "./pages/brand/BrandPortal";
import SEO from "./components/SEO";
import RedirectGate from "./components/RedirectGate";
import "./App.css";

export default function App() {
  return (
    <LanguageProvider>
      <SiteSettingsProvider>
      <AuthProvider>
        <BrandAuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
            <RedirectGate />
            <Routes>
              <Route element={<SiteLayout />}>
                <Route index element={<Home />} />
                <Route path="/kurumsal-cozumler" element={<CorporateSolutions />} />
                <Route path="/hizmetler" element={<Navigate to="/kurumsal-cozumler" replace />} />
                <Route path="/hizmetler/:slug" element={<ServiceLanding />} />
                <Route path="/dr-ai" element={<DrAi />} />
                <Route path="/dr-ai-ile-uret" element={<DrAiUret />} />
                <Route path="/bursa-web-tasarim" element={<BursaLanding />} />
                <Route path="/projeler" element={<Projects />} />
                <Route path="/projeler/:slug" element={<ProjectDetail />} />
                <Route path="/hakkimizda" element={<About />} />
                <Route path="/iletisim" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogDetail />} />
                <Route path="/proje-talep" element={<ProjectRequest />} />
                <Route path="/yasal" element={<LegalPage />} />
                <Route path="/tas-flow" element={<TasFlow />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/firma/giris" element={<BrandLogin />} />
              <Route path="/firma/panel" element={<BrandPortal />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </BrandAuthProvider>
      </AuthProvider>
      </SiteSettingsProvider>
    </LanguageProvider>
  );
}

function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#07111F] text-white px-6 text-center">
      <SEO title="404 - Sayfa Bulunamadı | Dijital Roket" description="Aradığınız sayfa bulunamadı. Dijital Roket ana sayfasına dönerek devam edebilirsiniz." noindex />
      <div className="font-heading text-7xl font-extrabold text-gradient">404</div>
      <p className="mt-4 text-white/70">Aradığınız sayfa bulunamadı.</p>
      <a href="/" className="mt-8 btn-primary">Ana Sayfaya Dön</a>
    </div>
  );
}
